const _temp0 = require("./style/_common.styl");
const _temp1 = require("./style/account.styl");
const _temp2 = require("./style/close.styl");
const _temp3 = require("./style/customer.styl");
const _temp4 = require("./style/index.styl");
const _temp5 = require("./style/open.styl");
const _temp6 = require("./style/pos.styl");
const _temp7 = require("./style/shift.styl");
const _temp8 = require("./style/visit.styl");
module.exports = {
  "_common": _temp0,
  "account": _temp1,
  "close": _temp2,
  "customer": _temp3,
  "index": _temp4,
  "open": _temp5,
  "pos": _temp6,
  "shift": _temp7,
  "visit": _temp8
}